<template>
  <el-dialog
    title="文件详情"
    :visible="visible"
    @close="onClose"
    @open="onOpen"
    width="40%"
    top="5%"
    :close-on-click-modal="false"
  >
    <el-form :model="item" ref="itemform" label-width="120px">
      <el-form-item label="文件名" prop="Name">
        <el-input v-model.trim="item.Name" :disabled="true"></el-input>
      </el-form-item>
      <el-form-item label="文件类型" prop="Type">
        <el-input
          v-model.trim="typeList[item.Type]"
          :disabled="true"
        ></el-input>
      </el-form-item>
      <el-form-item label="文件大小(B)" prop="Size">
        <el-input v-model.trim="item.Size" :disabled="true"></el-input>
      </el-form-item>
      <el-form-item label="上传者" prop="Person">
        <el-input v-model.trim="item.Person" :disabled="true"></el-input>
      </el-form-item>
      <el-form-item label="上传时间" prop="CreatedAt">
        <el-date-picker
          v-model="item.CreatedAt"
          style="width: 100%"
          type="datetime"
          :disabled="true"
        ></el-date-picker>
      </el-form-item>
      <el-form-item label="是否可删除" prop="CanDel">
        <el-switch v-model="item.CanDel"></el-switch>
      </el-form-item>
      <el-form-item label="说明" prop="Remark">
        <el-input
          v-model.trim="item.Remark"
          :autosize="{ minRows: 2 }"
          type="textarea"
          placeholder="请输入说明"
        ></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer">
      <el-button @click="onClose">
        <i class="fas fa-times"></i> 取 消
      </el-button>
      <el-button type="primary" @click="onSubmit" :disabled="submitting">
        <i class="far fa-save"></i> 确 定
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  props: {
    group: Number,
    value: Object,
    visible: Boolean,
  },
  data() {
    return {
      item: _.clone(this.value),
      submitting: false,
      typeList: {
        1: '文档', // 除了下面两种情况暂时都认为是文档
        2: '图片', // .jpg, .jpeg, .png, .gif
        3: '压缩包', // .zip, .rar
      },
    };
  },
  methods: {
    onOpen() {
      this.item = _.cloneDeep(this.value);
    },
    onClose() {
      this.$emit("update:visible", false);
      this.$emit("cancel");
      this.$refs.itemform.resetFields();
      this.submitting = false;
    },
    onSubmit() {
      this.$refs.itemform.validate((valid) => {
        if (!valid) {
          return;
        }
        this.submitting = true;

        this.$emit("input", this.item);
        const itemData = { ...this.item };
        this.$axios
          .request({
            url:
              this.group === 0
                ? `dci/file/${itemData.ID}`
                : `ipc/file/${itemData.ID}`,
            method: "put",
            data: itemData,
          })
          .then(() => {
            this.$message.success("编辑成功");
            this.$emit("form:updated", true);
            this.$emit("form:saved", true);
            this.$emit("update:visible", false);
          })
          .catch(({ response }) => {
            this.$sys.alarmResponse(response);
            this.$emit("form:updated", false);
            this.$emit("form:saved", false);
          })
          .finally(() => {
            this.submitting = false;
          });
      });
    },
  },
};
</script>
